import { Address } from "viem"

import { MEZO_CHAIN } from "#/shared/constants"
import { Router } from "#/shared/constants/artifacts"

import { useAllowanceERC20Token, useApproveERC20Token } from "../erc-20"

const useSwapApprove = (tokenIn: Address) => {
  const {
    approve,
    isPending: isApprovalPending,
    isWaitingForTxReceipt: isWaitingForApprovalReceipt,
    isError: isApprovalError,
  } = useApproveERC20Token(tokenIn, Router.address, MEZO_CHAIN.id)

  const { data: allowance, refetch: refetchAllowance } = useAllowanceERC20Token(
    tokenIn,
    Router.address,
    MEZO_CHAIN.id,
  )

  return {
    approveSwap: approve,
    swapAllowance: allowance,
    refetchAllowance,
    isApprovalError,
    isApprovalPending,
    isWaitingForApprovalReceipt,
  }
}

export default useSwapApprove
